import { render, staticRenderFns } from "./mineMsg.vue?vue&type=template&id=34432dcf&scoped=true"
import script from "./mineMsg.vue?vue&type=script&lang=js"
export * from "./mineMsg.vue?vue&type=script&lang=js"
import style0 from "./mineMsg.vue?vue&type=style&index=0&id=34432dcf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34432dcf",
  null
  
)

export default component.exports